import clsx from 'clsx';
import React from 'react';
import { AskAlfred } from './components/ask-alfred/AskAlfred';
import { CohortRead } from './components/cohort-read/CohortRead';
import { ThemeColor } from './kg-insight-constants';
import styles from './ReflexivityGraphLayout.module.scss';

export interface ReflexivityGraphLayoutProps {
  cohortReadTitle: string;
  askAlfredSuggestions: string[];
  headerNode: React.ReactNode;
  description: string;
  cohortRead: string;
  children: React.ReactNode;
  color?: ThemeColor;
}

export const ReflexivityGraphLayout = ({
  cohortReadTitle,
  askAlfredSuggestions,
  children,
  headerNode,
  description,
  cohortRead,
  color,
}: ReflexivityGraphLayoutProps) => {
  return (
    <div
      className={clsx(
        styles.root,
        color && {
          [styles.gold]: color === 'gold',
          [styles.indigo]: color === 'indigo',
          [styles.teal]: color === 'teal',
          [styles.purple]: color === 'purple',
        }
      )}
    >
      <div className={styles.body}>
        {headerNode}
        <div className={styles.description}>{description}</div>
        {children}
        <CohortRead title={cohortReadTitle} text={cohortRead} />
      </div>
      <AskAlfred suggestions={askAlfredSuggestions} />
    </div>
  );
};
